import { render, staticRenderFns } from "./GetToken.vue?vue&type=template&id=f2066ef8&scoped=true"
import script from "./GetToken.vue?vue&type=script&lang=js"
export * from "./GetToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2066ef8",
  null
  
)

export default component.exports